/***********************************************************************************
 * Vue Router
 *
 * @author Zip Co - Plugin Team
 *
 ***********************************************************************************/

import Vue from 'vue';
import Router from 'vue-router';
import Meta from 'vue-meta';
import config from '@/config/client';

Vue.use(Router);
Vue.use(Meta);

export const createRouter = (): Router => {
    const subPath = config.subPath;

    const router = new Router({
        mode: 'history',
        scrollBehavior: (): any => ({ x: 0, y: 0 }),
        routes: [
            {
                name: 'pairing',
                path: `${subPath}/`,
                component: (): any => import('@/views/Pairing')
            },
            {
                name: 'purchase',
                path: `${subPath}/purchase`,
                component: (): any => import('@/views/Purchase')
            },
            {
                name: 'refund',
                path: `${subPath}/refund`,
                component: (): any => import('@/views/Refund')
            },
            {
                path: '*',
                redirect: `${subPath}/`
            }
        ]
    });

    return router;
};
